/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindOperationTreeByProductIdQueryResponse,
  FindOperationTreeByProductIdPathParams,
} from "../types/FindOperationTreeByProductId.ts"

export const findOperationTreeByProductIdQueryKey = (
  productId: FindOperationTreeByProductIdPathParams["productId"]
) =>
  [
    {
      url: "/v1/operation/find-operation-tree-by-product-id/:productId",
      params: { productId },
    },
  ] as const

export type FindOperationTreeByProductIdQueryKey = ReturnType<
  typeof findOperationTreeByProductIdQueryKey
>

/**
 * @summary Find operation tree
 * {@link /v1/operation/find-operation-tree-by-product-id/:productId}
 */
export async function findOperationTreeByProductId(
  productId: FindOperationTreeByProductIdPathParams["productId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindOperationTreeByProductIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/operation/find-operation-tree-by-product-id/${productId}`,
    ...requestConfig,
  })
  return res
}

export function findOperationTreeByProductIdQueryOptions(
  productId: FindOperationTreeByProductIdPathParams["productId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findOperationTreeByProductIdQueryKey(productId)
  return queryOptions<
    ResponseConfig<FindOperationTreeByProductIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindOperationTreeByProductIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!productId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findOperationTreeByProductId(productId, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find operation tree
 * {@link /v1/operation/find-operation-tree-by-product-id/:productId}
 */
export function useFindOperationTreeByProductId<
  TData = ResponseConfig<FindOperationTreeByProductIdQueryResponse>,
  TQueryData = ResponseConfig<FindOperationTreeByProductIdQueryResponse>,
  TQueryKey extends QueryKey = FindOperationTreeByProductIdQueryKey,
>(
  productId: FindOperationTreeByProductIdPathParams["productId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindOperationTreeByProductIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findOperationTreeByProductIdQueryKey(productId)

  const query = useQuery(
    {
      ...findOperationTreeByProductIdQueryOptions(productId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
